import React, { useState, useEffect } from 'react';
import Slab from '../../../../helpers/slab/Slab';
import ReceivablesAppliedCashFlowTable from './Summary';
import Admin from './Admin';
import Get from '../../../../api/internal/Get';
import { useRoleAuthorization } from '../../../../hooks/useRoleAuthorization';
import { ADMIN_AUTHORIZED_ROLES } from '../../../../auth/AuthRoles';

interface ARAppliedPaymentsDataObject {
  Summary?: ARAppliedPaymentsSummary;
  Admin?: AppliedPaymentsAdmin;
}

function ARAppliedPayments({
  cashFlowId,
  startPage,
}: {
  cashFlowId: number;
  startPage?: String;
}) {
  const [currentPage, setCurrentPage] = useState();
  const [dataObject] = useState<ARAppliedPaymentsDataObject>({});

  useEffect(() => {
    startPage ? HandlePageChange(startPage) : HandlePageChange('Summary');
  }, []);
  const HandlePageChange = params => {
    if (!dataObject[params] && pages[params].callerPath) {
      Get(pages[params].callerPath).then(response => {
        if (response) {
          dataObject[params] = response.data;
          AssignPages();
          setCurrentPage(params);
        }
      });
    } else {
      setCurrentPage(params);
    }
  };

  function RefreshPage(currentPage, additionalPages) {
    setCurrentPage(null);
    delete dataObject[currentPage];
    additionalPages?.forEach(pageName => {
      delete dataObject[pageName];
    });
    HandlePageChange(currentPage);
  }

  let pages = {};
  AssignPages();
  function AssignPages() {
    pages = {
      Summary: {
        content: (
          <ReceivablesAppliedCashFlowTable
            cashFlowId={cashFlowId}
            data={dataObject.Summary}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/Accounting/GetCustomerAppliedCashFlows/${cashFlowId}`,
      },
    };
    if (useRoleAuthorization(ADMIN_AUTHORIZED_ROLES))
      pages['Admin'] = {
        content: (
          <Admin
            cashFlowId={cashFlowId}
            data={dataObject.Admin}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/Accounting/GetAppliedPaymentAdmin/${cashFlowId}`,
      };
  }

  return (
    <Slab
      title={'Applied Payments'}
      pages={pages}
      currentPage={currentPage}
      HandlePageChange={HandlePageChange}
      dataObject={dataObject}
    />
  );
}

export default ARAppliedPayments;
